import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { withRouter } from "react-router-dom";
import { useStyles } from "./SearchBook.css";

class SearchBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResult: "",
    };
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.props.history.push(`/search/query/${this.state.searchResult}`);
  };

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.handleSearch}>
        <TextField
          name="searchResult"
          type="text"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          placeholder="Search Books..."
          style={{ marginRight: 20 }}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={this.state.searchResult}
          onChange={(e) => this.setState({ searchResult: e.target.value })}
        />
      </form>
    );
  }
}

export default withStyles(useStyles)(withRouter(SearchBook));
